import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faClone } from "@fortawesome/free-solid-svg-icons";

import { Grid, IconButton, Tooltip } from "@mui/material";

import { Props, State } from "./interfaces";
import { Container, Typography } from "./styles";

const MaskedTypography = ({ value }: Props) => {
  const { t } = useTranslation();
  const tRP = "pages.document_reports.compliance_documents.passwords"; // tRP - translation root path

  const [state, setState] = useState<State>({
    masked: true,
    clipboardMessage: "",
    showClipboardMessage: false,
  });

  const setMasked = (value: boolean) => setState((state) => ({ ...state, masked: value }));

  const setClipboardMessage = (clipboardMessage: string) => setState((state) => ({ ...state, clipboardMessage }));

  const setShowClipboardMessage = (value: boolean) => setState((state) => ({ ...state, showClipboardMessage: value }));

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setShowClipboardMessage(true);
      setClipboardMessage(t(`${tRP}.clipboard_message_success`));
    } catch (error) {
      setClipboardMessage(`${`${tRP}.clipboard_message_error`}: ${error}`);
    }
  };

  useEffect(() => {
    if (state.showClipboardMessage) setTimeout(() => setShowClipboardMessage(false), 2000);
  }, [state.showClipboardMessage]);

  return (
    <Container>
      <Typography masked={state.masked}>{state.masked ? "******" : value}</Typography>
      <Grid>
        <IconButton
          onMouseDown={() => setMasked(false)}
          onMouseUp={() => setMasked(true)}
        >
          <FontAwesomeIcon icon={state.masked ? faEye : faEyeSlash} />
        </IconButton>
        <Tooltip
          open={state.showClipboardMessage}
          title={state.clipboardMessage}
          placement="right-start"
        >
          <IconButton onClick={copyToClipboard}>
            <FontAwesomeIcon icon={faClone} />
          </IconButton>
        </Tooltip>
      </Grid>
    </Container>
  );
};

export default MaskedTypography;
